(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['ot-cookies-injector'] = {}));
}(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	var classCallCheck = createCommonjsModule(function (module) {
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }

	  module.exports = _classCallCheck;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _classCallCheck = /*@__PURE__*/getDefaultExportFromCjs(classCallCheck);

	var createClass = createCommonjsModule(function (module) {
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }

	  module.exports = _createClass;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _createClass = /*@__PURE__*/getDefaultExportFromCjs(createClass);

	var assign = make_assign();
	var create = make_create();
	var trim = make_trim();
	var Global = typeof window !== 'undefined' ? window : commonjsGlobal;
	var util = {
	  assign: assign,
	  create: create,
	  trim: trim,
	  bind: bind,
	  slice: slice,
	  each: each,
	  map: map,
	  pluck: pluck,
	  isList: isList,
	  isFunction: isFunction,
	  isObject: isObject,
	  Global: Global
	};

	function make_assign() {
	  if (Object.assign) {
	    return Object.assign;
	  } else {
	    return function shimAssign(obj, props1, props2, etc) {
	      for (var i = 1; i < arguments.length; i++) {
	        each(Object(arguments[i]), function (val, key) {
	          obj[key] = val;
	        });
	      }

	      return obj;
	    };
	  }
	}

	function make_create() {
	  if (Object.create) {
	    return function create(obj, assignProps1, assignProps2, etc) {
	      var assignArgsList = slice(arguments, 1);
	      return assign.apply(this, [Object.create(obj)].concat(assignArgsList));
	    };
	  } else {
	    var F = function F() {}; // eslint-disable-line no-inner-declarations


	    return function create(obj, assignProps1, assignProps2, etc) {
	      var assignArgsList = slice(arguments, 1);
	      F.prototype = obj;
	      return assign.apply(this, [new F()].concat(assignArgsList));
	    };
	  }
	}

	function make_trim() {
	  if (String.prototype.trim) {
	    return function trim(str) {
	      return String.prototype.trim.call(str);
	    };
	  } else {
	    return function trim(str) {
	      return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	    };
	  }
	}

	function bind(obj, fn) {
	  return function () {
	    return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
	  };
	}

	function slice(arr, index) {
	  return Array.prototype.slice.call(arr, index || 0);
	}

	function each(obj, fn) {
	  pluck(obj, function (val, key) {
	    fn(val, key);
	    return false;
	  });
	}

	function map(obj, fn) {
	  var res = isList(obj) ? [] : {};
	  pluck(obj, function (v, k) {
	    res[k] = fn(v, k);
	    return false;
	  });
	  return res;
	}

	function pluck(obj, fn) {
	  if (isList(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      if (fn(obj[i], i)) {
	        return obj[i];
	      }
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        if (fn(obj[key], key)) {
	          return obj[key];
	        }
	      }
	    }
	  }
	}

	function isList(val) {
	  return val != null && typeof val != 'function' && typeof val.length == 'number';
	}

	function isFunction(val) {
	  return val && {}.toString.call(val) === '[object Function]';
	}

	function isObject(val) {
	  return val && {}.toString.call(val) === '[object Object]';
	}

	var slice$1 = util.slice;
	var pluck$1 = util.pluck;
	var each$1 = util.each;
	var bind$1 = util.bind;
	var create$1 = util.create;
	var isList$1 = util.isList;
	var isFunction$1 = util.isFunction;
	var isObject$1 = util.isObject;
	var storeEngine = {
	  createStore: _createStore
	};
	var storeAPI = {
	  version: '2.0.12',
	  enabled: false,
	  // get returns the value of the given key. If that value
	  // is undefined, it returns optionalDefaultValue instead.
	  get: function get(key, optionalDefaultValue) {
	    var data = this.storage.read(this._namespacePrefix + key);
	    return this._deserialize(data, optionalDefaultValue);
	  },
	  // set will store the given value at key and returns value.
	  // Calling set with value === undefined is equivalent to calling remove.
	  set: function set(key, value) {
	    if (value === undefined) {
	      return this.remove(key);
	    }

	    this.storage.write(this._namespacePrefix + key, this._serialize(value));
	    return value;
	  },
	  // remove deletes the key and value stored at the given key.
	  remove: function remove(key) {
	    this.storage.remove(this._namespacePrefix + key);
	  },
	  // each will call the given callback once for each key-value pair
	  // in this store.
	  each: function each(callback) {
	    var self = this;
	    this.storage.each(function (val, namespacedKey) {
	      callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
	    });
	  },
	  // clearAll will remove all the stored key-value pairs in this store.
	  clearAll: function clearAll() {
	    this.storage.clearAll();
	  },
	  // additional functionality that can't live in plugins
	  // ---------------------------------------------------
	  // hasNamespace returns true if this store instance has the given namespace.
	  hasNamespace: function hasNamespace(namespace) {
	    return this._namespacePrefix == '__storejs_' + namespace + '_';
	  },
	  // createStore creates a store.js instance with the first
	  // functioning storage in the list of storage candidates,
	  // and applies the the given mixins to the instance.
	  createStore: function createStore() {
	    return _createStore.apply(this, arguments);
	  },
	  addPlugin: function addPlugin(plugin) {
	    this._addPlugin(plugin);
	  },
	  namespace: function namespace(_namespace) {
	    return _createStore(this.storage, this.plugins, _namespace);
	  }
	};

	function _warn() {
	  var _console = typeof console == 'undefined' ? null : console;

	  if (!_console) {
	    return;
	  }

	  var fn = _console.warn ? _console.warn : _console.log;
	  fn.apply(_console, arguments);
	}

	function _createStore(storages, plugins, namespace) {
	  if (!namespace) {
	    namespace = '';
	  }

	  if (storages && !isList$1(storages)) {
	    storages = [storages];
	  }

	  if (plugins && !isList$1(plugins)) {
	    plugins = [plugins];
	  }

	  var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
	  var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
	  var legalNamespaces = /^[a-zA-Z0-9_\-]*$/; // alpha-numeric + underscore and dash

	  if (!legalNamespaces.test(namespace)) {
	    throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
	  }

	  var _privateStoreProps = {
	    _namespacePrefix: namespacePrefix,
	    _namespaceRegexp: namespaceRegexp,
	    _testStorage: function _testStorage(storage) {
	      try {
	        var testStr = '__storejs__test__';
	        storage.write(testStr, testStr);
	        var ok = storage.read(testStr) === testStr;
	        storage.remove(testStr);
	        return ok;
	      } catch (e) {
	        return false;
	      }
	    },
	    _assignPluginFnProp: function _assignPluginFnProp(pluginFnProp, propName) {
	      var oldFn = this[propName];

	      this[propName] = function pluginFn() {
	        var args = slice$1(arguments, 0);
	        var self = this; // super_fn calls the old function which was overwritten by
	        // this mixin.

	        function super_fn() {
	          if (!oldFn) {
	            return;
	          }

	          each$1(arguments, function (arg, i) {
	            args[i] = arg;
	          });
	          return oldFn.apply(self, args);
	        } // Give mixing function access to super_fn by prefixing all mixin function
	        // arguments with super_fn.


	        var newFnArgs = [super_fn].concat(args);
	        return pluginFnProp.apply(self, newFnArgs);
	      };
	    },
	    _serialize: function _serialize(obj) {
	      return JSON.stringify(obj);
	    },
	    _deserialize: function _deserialize(strVal, defaultVal) {
	      if (!strVal) {
	        return defaultVal;
	      } // It is possible that a raw string value has been previously stored
	      // in a storage without using store.js, meaning it will be a raw
	      // string value instead of a JSON serialized string. By defaulting
	      // to the raw string value in case of a JSON parse error, we allow
	      // for past stored values to be forwards-compatible with store.js


	      var val = '';

	      try {
	        val = JSON.parse(strVal);
	      } catch (e) {
	        val = strVal;
	      }

	      return val !== undefined ? val : defaultVal;
	    },
	    _addStorage: function _addStorage(storage) {
	      if (this.enabled) {
	        return;
	      }

	      if (this._testStorage(storage)) {
	        this.storage = storage;
	        this.enabled = true;
	      }
	    },
	    _addPlugin: function _addPlugin(plugin) {
	      var self = this; // If the plugin is an array, then add all plugins in the array.
	      // This allows for a plugin to depend on other plugins.

	      if (isList$1(plugin)) {
	        each$1(plugin, function (plugin) {
	          self._addPlugin(plugin);
	        });
	        return;
	      } // Keep track of all plugins we've seen so far, so that we
	      // don't add any of them twice.


	      var seenPlugin = pluck$1(this.plugins, function (seenPlugin) {
	        return plugin === seenPlugin;
	      });

	      if (seenPlugin) {
	        return;
	      }

	      this.plugins.push(plugin); // Check that the plugin is properly formed

	      if (!isFunction$1(plugin)) {
	        throw new Error('Plugins must be function values that return objects');
	      }

	      var pluginProperties = plugin.call(this);

	      if (!isObject$1(pluginProperties)) {
	        throw new Error('Plugins must return an object of function properties');
	      } // Add the plugin function properties to this store instance.


	      each$1(pluginProperties, function (pluginFnProp, propName) {
	        if (!isFunction$1(pluginFnProp)) {
	          throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
	        }

	        self._assignPluginFnProp(pluginFnProp, propName);
	      });
	    },
	    // Put deprecated properties in the private API, so as to not expose it to accidential
	    // discovery through inspection of the store object.
	    // Deprecated: addStorage
	    addStorage: function addStorage(storage) {
	      _warn('store.addStorage(storage) is deprecated. Use createStore([storages])');

	      this._addStorage(storage);
	    }
	  };
	  var store = create$1(_privateStoreProps, storeAPI, {
	    plugins: []
	  });
	  store.raw = {};
	  each$1(store, function (prop, propName) {
	    if (isFunction$1(prop)) {
	      store.raw[propName] = bind$1(store, prop);
	    }
	  });
	  each$1(storages, function (storage) {
	    store._addStorage(storage);
	  });
	  each$1(plugins, function (plugin) {
	    store._addPlugin(plugin);
	  });
	  return store;
	}

	var Global$1 = util.Global;
	var localStorage_1 = {
	  name: 'localStorage',
	  read: read,
	  write: write,
	  each: each$2,
	  remove: remove,
	  clearAll: clearAll
	};

	function localStorage() {
	  return Global$1.localStorage;
	}

	function read(key) {
	  return localStorage().getItem(key);
	}

	function write(key, data) {
	  return localStorage().setItem(key, data);
	}

	function each$2(fn) {
	  for (var i = localStorage().length - 1; i >= 0; i--) {
	    var key = localStorage().key(i);
	    fn(read(key), key);
	  }
	}

	function remove(key) {
	  return localStorage().removeItem(key);
	}

	function clearAll() {
	  return localStorage().clear();
	}

	// versions 6 and 7, where no localStorage, etc
	// is available.

	var Global$2 = util.Global;
	var oldFFGlobalStorage = {
	  name: 'oldFF-globalStorage',
	  read: read$1,
	  write: write$1,
	  each: each$3,
	  remove: remove$1,
	  clearAll: clearAll$1
	};
	var globalStorage = Global$2.globalStorage;

	function read$1(key) {
	  return globalStorage[key];
	}

	function write$1(key, data) {
	  globalStorage[key] = data;
	}

	function each$3(fn) {
	  for (var i = globalStorage.length - 1; i >= 0; i--) {
	    var key = globalStorage.key(i);
	    fn(globalStorage[key], key);
	  }
	}

	function remove$1(key) {
	  return globalStorage.removeItem(key);
	}

	function clearAll$1() {
	  each$3(function (key, _) {
	    delete globalStorage[key];
	  });
	}

	// versions 6 and 7, where no localStorage, sessionStorage, etc
	// is available.

	var Global$3 = util.Global;
	var oldIEUserDataStorage = {
	  name: 'oldIE-userDataStorage',
	  write: write$2,
	  read: read$2,
	  each: each$4,
	  remove: remove$2,
	  clearAll: clearAll$2
	};
	var storageName = 'storejs';
	var doc = Global$3.document;

	var _withStorageEl = _makeIEStorageElFunction();

	var disable = (Global$3.navigator ? Global$3.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./); // MSIE 9.x, MSIE 10.x

	function write$2(unfixedKey, data) {
	  if (disable) {
	    return;
	  }

	  var fixedKey = fixKey(unfixedKey);

	  _withStorageEl(function (storageEl) {
	    storageEl.setAttribute(fixedKey, data);
	    storageEl.save(storageName);
	  });
	}

	function read$2(unfixedKey) {
	  if (disable) {
	    return;
	  }

	  var fixedKey = fixKey(unfixedKey);
	  var res = null;

	  _withStorageEl(function (storageEl) {
	    res = storageEl.getAttribute(fixedKey);
	  });

	  return res;
	}

	function each$4(callback) {
	  _withStorageEl(function (storageEl) {
	    var attributes = storageEl.XMLDocument.documentElement.attributes;

	    for (var i = attributes.length - 1; i >= 0; i--) {
	      var attr = attributes[i];
	      callback(storageEl.getAttribute(attr.name), attr.name);
	    }
	  });
	}

	function remove$2(unfixedKey) {
	  var fixedKey = fixKey(unfixedKey);

	  _withStorageEl(function (storageEl) {
	    storageEl.removeAttribute(fixedKey);
	    storageEl.save(storageName);
	  });
	}

	function clearAll$2() {
	  _withStorageEl(function (storageEl) {
	    var attributes = storageEl.XMLDocument.documentElement.attributes;
	    storageEl.load(storageName);

	    for (var i = attributes.length - 1; i >= 0; i--) {
	      storageEl.removeAttribute(attributes[i].name);
	    }

	    storageEl.save(storageName);
	  });
	} // Helpers
	//////////
	// In IE7, keys cannot start with a digit or contain certain chars.
	// See https://github.com/marcuswestin/store.js/issues/40
	// See https://github.com/marcuswestin/store.js/issues/83


	var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");

	function fixKey(key) {
	  return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___');
	}

	function _makeIEStorageElFunction() {
	  if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
	    return null;
	  }

	  var scriptTag = 'script',
	      storageOwner,
	      storageContainer,
	      storageEl; // Since #userData storage applies only to specific paths, we need to
	  // somehow link our data to a specific path.  We choose /favicon.ico
	  // as a pretty safe option, since all browsers already make a request to
	  // this URL anyway and being a 404 will not hurt us here.  We wrap an
	  // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	  // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	  // since the iframe access rules appear to allow direct access and
	  // manipulation of the document element, even for a 404 page.  This
	  // document can be used instead of the current document (which would
	  // have been limited to the current path) to perform #userData storage.

	  try {
	    /* global ActiveXObject */
	    storageContainer = new ActiveXObject('htmlfile');
	    storageContainer.open();
	    storageContainer.write('<' + scriptTag + '>document.w=window</' + scriptTag + '><iframe src="/favicon.ico"></iframe>');
	    storageContainer.close();
	    storageOwner = storageContainer.w.frames[0].document;
	    storageEl = storageOwner.createElement('div');
	  } catch (e) {
	    // somehow ActiveXObject instantiation failed (perhaps some special
	    // security settings or otherwse), fall back to per-path storage
	    storageEl = doc.createElement('div');
	    storageOwner = doc.body;
	  }

	  return function (storeFunction) {
	    var args = [].slice.call(arguments, 0);
	    args.unshift(storageEl); // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
	    // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx

	    storageOwner.appendChild(storageEl);
	    storageEl.addBehavior('#default#userData');
	    storageEl.load(storageName);
	    storeFunction.apply(this, args);
	    storageOwner.removeChild(storageEl);
	    return;
	  };
	}

	// doesn't work but cookies do. This implementation is adopted from
	// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

	var Global$4 = util.Global;
	var trim$1 = util.trim;
	var cookieStorage = {
	  name: 'cookieStorage',
	  read: read$3,
	  write: write$3,
	  each: each$5,
	  remove: remove$3,
	  clearAll: clearAll$3
	};
	var doc$1 = Global$4.document;

	function read$3(key) {
	  if (!key || !_has(key)) {
	    return null;
	  }

	  var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
	  return unescape(doc$1.cookie.replace(new RegExp(regexpStr), "$1"));
	}

	function each$5(callback) {
	  var cookies = doc$1.cookie.split(/; ?/g);

	  for (var i = cookies.length - 1; i >= 0; i--) {
	    if (!trim$1(cookies[i])) {
	      continue;
	    }

	    var kvp = cookies[i].split('=');
	    var key = unescape(kvp[0]);
	    var val = unescape(kvp[1]);
	    callback(val, key);
	  }
	}

	function write$3(key, data) {
	  if (!key) {
	    return;
	  }

	  doc$1.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
	}

	function remove$3(key) {
	  if (!key || !_has(key)) {
	    return;
	  }

	  doc$1.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
	}

	function clearAll$3() {
	  each$5(function (_, key) {
	    remove$3(key);
	  });
	}

	function _has(key) {
	  return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(doc$1.cookie);
	}

	var Global$5 = util.Global;
	var sessionStorage_1 = {
	  name: 'sessionStorage',
	  read: read$4,
	  write: write$4,
	  each: each$6,
	  remove: remove$4,
	  clearAll: clearAll$4
	};

	function sessionStorage() {
	  return Global$5.sessionStorage;
	}

	function read$4(key) {
	  return sessionStorage().getItem(key);
	}

	function write$4(key, data) {
	  return sessionStorage().setItem(key, data);
	}

	function each$6(fn) {
	  for (var i = sessionStorage().length - 1; i >= 0; i--) {
	    var key = sessionStorage().key(i);
	    fn(read$4(key), key);
	  }
	}

	function remove$4(key) {
	  return sessionStorage().removeItem(key);
	}

	function clearAll$4() {
	  return sessionStorage().clear();
	}

	// memoryStorage is a useful last fallback to ensure that the store
	// is functions (meaning store.get(), store.set(), etc will all function).
	// However, stored values will not persist when the browser navigates to
	// a new page or reloads the current page.
	var memoryStorage_1 = {
	  name: 'memoryStorage',
	  read: read$5,
	  write: write$5,
	  each: each$7,
	  remove: remove$5,
	  clearAll: clearAll$5
	};
	var memoryStorage = {};

	function read$5(key) {
	  return memoryStorage[key];
	}

	function write$5(key, data) {
	  memoryStorage[key] = data;
	}

	function each$7(callback) {
	  for (var key in memoryStorage) {
	    if (memoryStorage.hasOwnProperty(key)) {
	      callback(memoryStorage[key], key);
	    }
	  }
	}

	function remove$5(key) {
	  delete memoryStorage[key];
	}

	function clearAll$5(key) {
	  memoryStorage = {};
	}

	var all = [// Listed in order of usage preference
	localStorage_1, oldFFGlobalStorage, oldIEUserDataStorage, cookieStorage, sessionStorage_1, memoryStorage_1];

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	/* eslint-disable */
	//  json2.js
	//  2016-10-28
	//  Public Domain.
	//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	//  See http://www.JSON.org/js.html
	//  This code should be minified before deployment.
	//  See http://javascript.crockford.com/jsmin.html
	//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	//  NOT CONTROL.
	//  This file creates a global JSON object containing two methods: stringify
	//  and parse. This file provides the ES5 JSON capability to ES3 systems.
	//  If a project might run on IE8 or earlier, then this file should be included.
	//  This file does nothing on ES5 systems.
	//      JSON.stringify(value, replacer, space)
	//          value       any JavaScript value, usually an object or array.
	//          replacer    an optional parameter that determines how object
	//                      values are stringified for objects. It can be a
	//                      function or an array of strings.
	//          space       an optional parameter that specifies the indentation
	//                      of nested structures. If it is omitted, the text will
	//                      be packed without extra whitespace. If it is a number,
	//                      it will specify the number of spaces to indent at each
	//                      level. If it is a string (such as "\t" or "&nbsp;"),
	//                      it contains the characters used to indent at each level.
	//          This method produces a JSON text from a JavaScript value.
	//          When an object value is found, if the object contains a toJSON
	//          method, its toJSON method will be called and the result will be
	//          stringified. A toJSON method does not serialize: it returns the
	//          value represented by the name/value pair that should be serialized,
	//          or undefined if nothing should be serialized. The toJSON method
	//          will be passed the key associated with the value, and this will be
	//          bound to the value.
	//          For example, this would serialize Dates as ISO strings.
	//              Date.prototype.toJSON = function (key) {
	//                  function f(n) {
	//                      // Format integers to have at least two digits.
	//                      return (n < 10)
	//                          ? "0" + n
	//                          : n;
	//                  }
	//                  return this.getUTCFullYear()   + "-" +
	//                       f(this.getUTCMonth() + 1) + "-" +
	//                       f(this.getUTCDate())      + "T" +
	//                       f(this.getUTCHours())     + ":" +
	//                       f(this.getUTCMinutes())   + ":" +
	//                       f(this.getUTCSeconds())   + "Z";
	//              };
	//          You can provide an optional replacer method. It will be passed the
	//          key and value of each member, with this bound to the containing
	//          object. The value that is returned from your method will be
	//          serialized. If your method returns undefined, then the member will
	//          be excluded from the serialization.
	//          If the replacer parameter is an array of strings, then it will be
	//          used to select the members to be serialized. It filters the results
	//          such that only members with keys listed in the replacer array are
	//          stringified.
	//          Values that do not have JSON representations, such as undefined or
	//          functions, will not be serialized. Such values in objects will be
	//          dropped; in arrays they will be replaced with null. You can use
	//          a replacer function to replace those with JSON values.
	//          JSON.stringify(undefined) returns undefined.
	//          The optional space parameter produces a stringification of the
	//          value that is filled with line breaks and indentation to make it
	//          easier to read.
	//          If the space parameter is a non-empty string, then that string will
	//          be used for indentation. If the space parameter is a number, then
	//          the indentation will be that many spaces.
	//          Example:
	//          text = JSON.stringify(["e", {pluribus: "unum"}]);
	//          // text is '["e",{"pluribus":"unum"}]'
	//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
	//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	//          text = JSON.stringify([new Date()], function (key, value) {
	//              return this[key] instanceof Date
	//                  ? "Date(" + this[key] + ")"
	//                  : value;
	//          });
	//          // text is '["Date(---current time---)"]'
	//      JSON.parse(text, reviver)
	//          This method parses a JSON text to produce an object or array.
	//          It can throw a SyntaxError exception.
	//          The optional reviver parameter is a function that can filter and
	//          transform the results. It receives each of the keys and values,
	//          and its return value is used instead of the original value.
	//          If it returns what it received, then the structure is not modified.
	//          If it returns undefined then the member is deleted.
	//          Example:
	//          // Parse the text. Values that look like ISO date strings will
	//          // be converted to Date objects.
	//          myData = JSON.parse(text, function (key, value) {
	//              var a;
	//              if (typeof value === "string") {
	//                  a =
	//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	//                  if (a) {
	//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	//                          +a[5], +a[6]));
	//                  }
	//              }
	//              return value;
	//          });
	//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	//              var d;
	//              if (typeof value === "string" &&
	//                      value.slice(0, 5) === "Date(" &&
	//                      value.slice(-1) === ")") {
	//                  d = new Date(value.slice(5, -1));
	//                  if (d) {
	//                      return d;
	//                  }
	//              }
	//              return value;
	//          });
	//  This is a reference implementation. You are free to copy, modify, or
	//  redistribute.

	/*jslint
	    eval, for, this
	*/

	/*property
	    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	    lastIndex, length, parse, prototype, push, replace, slice, stringify,
	    test, toJSON, toString, valueOf
	*/
	// Create a JSON object only if one does not already exist. We create the
	// methods in a closure to avoid creating global variables.
	if ((typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) !== "object") {
	  JSON = {};
	}

	(function () {

	  var rx_one = /^[\],:{}\s]*$/;
	  var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	  var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	  var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
	  var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	  var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

	  function f(n) {
	    // Format integers to have at least two digits.
	    return n < 10 ? "0" + n : n;
	  }

	  function this_value() {
	    return this.valueOf();
	  }

	  if (typeof Date.prototype.toJSON !== "function") {
	    Date.prototype.toJSON = function () {
	      return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
	    };

	    Boolean.prototype.toJSON = this_value;
	    Number.prototype.toJSON = this_value;
	    String.prototype.toJSON = this_value;
	  }

	  var gap;
	  var indent;
	  var meta;
	  var rep;

	  function quote(string) {
	    // If the string contains no control characters, no quote characters, and no
	    // backslash characters, then we can safely slap some quotes around it.
	    // Otherwise we must also replace the offending characters with safe escape
	    // sequences.
	    rx_escapable.lastIndex = 0;
	    return rx_escapable.test(string) ? "\"" + string.replace(rx_escapable, function (a) {
	      var c = meta[a];
	      return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	    }) + "\"" : "\"" + string + "\"";
	  }

	  function str(key, holder) {
	    // Produce a string from holder[key].
	    var i; // The loop counter.

	    var k; // The member key.

	    var v; // The member value.

	    var length;
	    var mind = gap;
	    var partial;
	    var value = holder[key]; // If the value has a toJSON method, call it to obtain a replacement value.

	    if (value && _typeof(value) === "object" && typeof value.toJSON === "function") {
	      value = value.toJSON(key);
	    } // If we were called with a replacer function, then call the replacer to
	    // obtain a replacement value.


	    if (typeof rep === "function") {
	      value = rep.call(holder, key, value);
	    } // What happens next depends on the value's type.


	    switch (_typeof(value)) {
	      case "string":
	        return quote(value);

	      case "number":
	        // JSON numbers must be finite. Encode non-finite numbers as null.
	        return isFinite(value) ? String(value) : "null";

	      case "boolean":
	      case "null":
	        // If the value is a boolean or null, convert it to a string. Note:
	        // typeof null does not produce "null". The case is included here in
	        // the remote chance that this gets fixed someday.
	        return String(value);
	      // If the type is "object", we might be dealing with an object or an array or
	      // null.

	      case "object":
	        // Due to a specification blunder in ECMAScript, typeof null is "object",
	        // so watch out for that case.
	        if (!value) {
	          return "null";
	        } // Make an array to hold the partial results of stringifying this object value.


	        gap += indent;
	        partial = []; // Is the value an array?

	        if (Object.prototype.toString.apply(value) === "[object Array]") {
	          // The value is an array. Stringify every element. Use null as a placeholder
	          // for non-JSON values.
	          length = value.length;

	          for (i = 0; i < length; i += 1) {
	            partial[i] = str(i, value) || "null";
	          } // Join all of the elements together, separated with commas, and wrap them in
	          // brackets.


	          v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
	          gap = mind;
	          return v;
	        } // If the replacer is an array, use it to select the members to be stringified.


	        if (rep && _typeof(rep) === "object") {
	          length = rep.length;

	          for (i = 0; i < length; i += 1) {
	            if (typeof rep[i] === "string") {
	              k = rep[i];
	              v = str(k, value);

	              if (v) {
	                partial.push(quote(k) + (gap ? ": " : ":") + v);
	              }
	            }
	          }
	        } else {
	          // Otherwise, iterate through all of the keys in the object.
	          for (k in value) {
	            if (Object.prototype.hasOwnProperty.call(value, k)) {
	              v = str(k, value);

	              if (v) {
	                partial.push(quote(k) + (gap ? ": " : ":") + v);
	              }
	            }
	          }
	        } // Join all of the member texts together, separated with commas,
	        // and wrap them in braces.


	        v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
	        gap = mind;
	        return v;
	    }
	  } // If the JSON object does not yet have a stringify method, give it one.


	  if (typeof JSON.stringify !== "function") {
	    meta = {
	      // table of character substitutions
	      "\b": "\\b",
	      "\t": "\\t",
	      "\n": "\\n",
	      "\f": "\\f",
	      "\r": "\\r",
	      "\"": "\\\"",
	      "\\": "\\\\"
	    };

	    JSON.stringify = function (value, replacer, space) {
	      // The stringify method takes a value and an optional replacer, and an optional
	      // space parameter, and returns a JSON text. The replacer can be a function
	      // that can replace values, or an array of strings that will select the keys.
	      // A default replacer method can be provided. Use of the space parameter can
	      // produce text that is more easily readable.
	      var i;
	      gap = "";
	      indent = ""; // If the space parameter is a number, make an indent string containing that
	      // many spaces.

	      if (typeof space === "number") {
	        for (i = 0; i < space; i += 1) {
	          indent += " ";
	        } // If the space parameter is a string, it will be used as the indent string.

	      } else if (typeof space === "string") {
	        indent = space;
	      } // If there is a replacer, it must be a function or an array.
	      // Otherwise, throw an error.


	      rep = replacer;

	      if (replacer && typeof replacer !== "function" && (_typeof(replacer) !== "object" || typeof replacer.length !== "number")) {
	        throw new Error("JSON.stringify");
	      } // Make a fake root object containing our value under the key of "".
	      // Return the result of stringifying the value.


	      return str("", {
	        "": value
	      });
	    };
	  } // If the JSON object does not yet have a parse method, give it one.


	  if (typeof JSON.parse !== "function") {
	    JSON.parse = function (text, reviver) {
	      // The parse method takes a text and an optional reviver function, and returns
	      // a JavaScript value if the text is a valid JSON text.
	      var j;

	      function walk(holder, key) {
	        // The walk method is used to recursively walk the resulting structure so
	        // that modifications can be made.
	        var k;
	        var v;
	        var value = holder[key];

	        if (value && _typeof(value) === "object") {
	          for (k in value) {
	            if (Object.prototype.hasOwnProperty.call(value, k)) {
	              v = walk(value, k);

	              if (v !== undefined) {
	                value[k] = v;
	              } else {
	                delete value[k];
	              }
	            }
	          }
	        }

	        return reviver.call(holder, key, value);
	      } // Parsing happens in four stages. In the first stage, we replace certain
	      // Unicode characters with escape sequences. JavaScript handles many characters
	      // incorrectly, either silently deleting them, or treating them as line endings.


	      text = String(text);
	      rx_dangerous.lastIndex = 0;

	      if (rx_dangerous.test(text)) {
	        text = text.replace(rx_dangerous, function (a) {
	          return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	        });
	      } // In the second stage, we run the text against regular expressions that look
	      // for non-JSON patterns. We are especially concerned with "()" and "new"
	      // because they can cause invocation, and "=" because it can cause mutation.
	      // But just to be safe, we want to reject all unexpected forms.
	      // We split the second stage into 4 regexp operations in order to work around
	      // crippling inefficiencies in IE's and Safari's regexp engines. First we
	      // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
	      // replace all simple value tokens with "]" characters. Third, we delete all
	      // open brackets that follow a colon or comma or that begin the text. Finally,
	      // we look to see that the remaining characters are only whitespace or "]" or
	      // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.


	      if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
	        // In the third stage we use the eval function to compile the text into a
	        // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
	        // in JavaScript: it can begin a block or an object literal. We wrap the text
	        // in parens to eliminate the ambiguity.
	        j = eval("(" + text + ")"); // In the optional fourth stage, we recursively walk the new structure, passing
	        // each name/value pair to a reviver function for possible transformation.

	        return typeof reviver === "function" ? walk({
	          "": j
	        }, "") : j;
	      } // If the text is not JSON parseable, then a SyntaxError is thrown.


	      throw new SyntaxError("JSON.parse");
	    };
	  }
	})();

	var json2 = json2Plugin;

	function json2Plugin() {
	  return {};
	}

	var plugins = [json2];
	var store_legacy = storeEngine.createStore(all, plugins);

	var PREFS_STORE_KEY = 'openticket:cookieprefs';
	/**
	 *  This class is used (by the provider) to handle
	 *  the storage of the user's cookie preferences.
	 */

	var OpenTicketCookieStorage = /*#__PURE__*/function () {
	  function OpenTicketCookieStorage() {
	    _classCallCheck(this, OpenTicketCookieStorage);
	  }

	  _createClass(OpenTicketCookieStorage, [{
	    key: "set",
	    value:
	    /**
	     *  Used to save the forwarded preferences in the store.
	     */
	    function set(prefs) {
	      store_legacy.set(PREFS_STORE_KEY, prefs);
	      return this.get();
	    }
	    /**
	     *  Used to get the preferences out of the store.
	     */

	  }, {
	    key: "get",
	    value: function get() {
	      return store_legacy.get(PREFS_STORE_KEY);
	    }
	    /**
	     *  Used to remove the preferences cookie. Returns the result
	     *  of getting the store - which must be undefined because it
	     *  got removed - to make sure it really got removed.
	     */

	  }, {
	    key: "remove",
	    value: function remove() {
	      store_legacy.remove(PREFS_STORE_KEY);
	      return this.get();
	    }
	  }]);

	  return OpenTicketCookieStorage;
	}();

	var defineProperty = createCommonjsModule(function (module) {
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }

	    return obj;
	  }

	  module.exports = _defineProperty;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty);

	var setPrototypeOf = createCommonjsModule(function (module) {
	  function _setPrototypeOf(o, p) {
	    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };

	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	    return _setPrototypeOf(o, p);
	  }

	  module.exports = _setPrototypeOf;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});

	var inherits = createCommonjsModule(function (module) {
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }

	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) setPrototypeOf(subClass, superClass);
	  }

	  module.exports = _inherits;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _inherits = /*@__PURE__*/getDefaultExportFromCjs(inherits);

	var _typeof_1 = createCommonjsModule(function (module) {
	  function _typeof(obj) {
	    "@babel/helpers - typeof";

	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      module.exports = _typeof = function _typeof(obj) {
	        return typeof obj;
	      };

	      module.exports["default"] = module.exports, module.exports.__esModule = true;
	    } else {
	      module.exports = _typeof = function _typeof(obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };

	      module.exports["default"] = module.exports, module.exports.__esModule = true;
	    }

	    return _typeof(obj);
	  }

	  module.exports = _typeof;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});

	var assertThisInitialized = createCommonjsModule(function (module) {
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }

	    return self;
	  }

	  module.exports = _assertThisInitialized;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});

	var possibleConstructorReturn = createCommonjsModule(function (module) {
	  var _typeof = _typeof_1["default"];

	  function _possibleConstructorReturn(self, call) {
	    if (call && (_typeof(call) === "object" || typeof call === "function")) {
	      return call;
	    }

	    return assertThisInitialized(self);
	  }

	  module.exports = _possibleConstructorReturn;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _possibleConstructorReturn = /*@__PURE__*/getDefaultExportFromCjs(possibleConstructorReturn);

	var getPrototypeOf = createCommonjsModule(function (module) {
	  function _getPrototypeOf(o) {
	    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	    return _getPrototypeOf(o);
	  }

	  module.exports = _getPrototypeOf;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _getPrototypeOf = /*@__PURE__*/getDefaultExportFromCjs(getPrototypeOf);

	var runtime_1 = createCommonjsModule(function (module) {
	  var runtime = function (exports) {

	    var Op = Object.prototype;
	    var hasOwn = Op.hasOwnProperty;
	    var undefined$1; // More compressible than void 0.

	    var $Symbol = typeof Symbol === "function" ? Symbol : {};
	    var iteratorSymbol = $Symbol.iterator || "@@iterator";
	    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	    function define(obj, key, value) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	      return obj[key];
	    }

	    try {
	      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	      define({}, "");
	    } catch (err) {
	      define = function define(obj, key, value) {
	        return obj[key] = value;
	      };
	    }

	    function wrap(innerFn, outerFn, self, tryLocsList) {
	      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	      var generator = Object.create(protoGenerator.prototype);
	      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
	      // .throw, and .return methods.

	      generator._invoke = makeInvokeMethod(innerFn, self, context);
	      return generator;
	    }

	    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
	    // record like context.tryEntries[i].completion. This interface could
	    // have been (and was previously) designed to take a closure to be
	    // invoked without arguments, but in all the cases we care about we
	    // already have an existing method we want to call, so there's no need
	    // to create a new function object. We can even get away with assuming
	    // the method takes exactly one argument, since that happens to be true
	    // in every case, so we don't have to touch the arguments object. The
	    // only additional allocation required is the completion record, which
	    // has a stable shape and so hopefully should be cheap to allocate.

	    function tryCatch(fn, obj, arg) {
	      try {
	        return {
	          type: "normal",
	          arg: fn.call(obj, arg)
	        };
	      } catch (err) {
	        return {
	          type: "throw",
	          arg: err
	        };
	      }
	    }

	    var GenStateSuspendedStart = "suspendedStart";
	    var GenStateSuspendedYield = "suspendedYield";
	    var GenStateExecuting = "executing";
	    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
	    // breaking out of the dispatch switch statement.

	    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
	    // .constructor.prototype properties for functions that return Generator
	    // objects. For full spec compliance, you may wish to configure your
	    // minifier not to mangle the names of these two functions.

	    function Generator() {}

	    function GeneratorFunction() {}

	    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
	    // don't natively support it.


	    var IteratorPrototype = {};

	    IteratorPrototype[iteratorSymbol] = function () {
	      return this;
	    };

	    var getProto = Object.getPrototypeOf;
	    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

	    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	      // This environment has a native %IteratorPrototype%; use it instead
	      // of the polyfill.
	      IteratorPrototype = NativeIteratorPrototype;
	    }

	    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	    GeneratorFunctionPrototype.constructor = GeneratorFunction;
	    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
	    // Iterator interface in terms of a single ._invoke method.

	    function defineIteratorMethods(prototype) {
	      ["next", "throw", "return"].forEach(function (method) {
	        define(prototype, method, function (arg) {
	          return this._invoke(method, arg);
	        });
	      });
	    }

	    exports.isGeneratorFunction = function (genFun) {
	      var ctor = typeof genFun === "function" && genFun.constructor;
	      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
	      // do is to check its .name property.
	      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	    };

	    exports.mark = function (genFun) {
	      if (Object.setPrototypeOf) {
	        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	      } else {
	        genFun.__proto__ = GeneratorFunctionPrototype;
	        define(genFun, toStringTagSymbol, "GeneratorFunction");
	      }

	      genFun.prototype = Object.create(Gp);
	      return genFun;
	    }; // Within the body of any async function, `await x` is transformed to
	    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	    // `hasOwn.call(value, "__await")` to determine if the yielded value is
	    // meant to be awaited.


	    exports.awrap = function (arg) {
	      return {
	        __await: arg
	      };
	    };

	    function AsyncIterator(generator, PromiseImpl) {
	      function invoke(method, arg, resolve, reject) {
	        var record = tryCatch(generator[method], generator, arg);

	        if (record.type === "throw") {
	          reject(record.arg);
	        } else {
	          var result = record.arg;
	          var value = result.value;

	          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
	            return PromiseImpl.resolve(value.__await).then(function (value) {
	              invoke("next", value, resolve, reject);
	            }, function (err) {
	              invoke("throw", err, resolve, reject);
	            });
	          }

	          return PromiseImpl.resolve(value).then(function (unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration.
	            result.value = unwrapped;
	            resolve(result);
	          }, function (error) {
	            // If a rejected Promise was yielded, throw the rejection back
	            // into the async generator function so it can be handled there.
	            return invoke("throw", error, resolve, reject);
	          });
	        }
	      }

	      var previousPromise;

	      function enqueue(method, arg) {
	        function callInvokeWithMethodAndArg() {
	          return new PromiseImpl(function (resolve, reject) {
	            invoke(method, arg, resolve, reject);
	          });
	        }

	        return previousPromise = // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
	        // invocations of the iterator.
	        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      } // Define the unified helper method that is used to implement .next,
	      // .throw, and .return (see defineIteratorMethods).


	      this._invoke = enqueue;
	    }

	    defineIteratorMethods(AsyncIterator.prototype);

	    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	      return this;
	    };

	    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
	    // AsyncIterator objects; they just return a Promise for the value of
	    // the final result produced by the iterator.

	    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	      if (PromiseImpl === void 0) PromiseImpl = Promise;
	      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function (result) {
	        return result.done ? result.value : iter.next();
	      });
	    };

	    function makeInvokeMethod(innerFn, self, context) {
	      var state = GenStateSuspendedStart;
	      return function invoke(method, arg) {
	        if (state === GenStateExecuting) {
	          throw new Error("Generator is already running");
	        }

	        if (state === GenStateCompleted) {
	          if (method === "throw") {
	            throw arg;
	          } // Be forgiving, per 25.3.3.3.3 of the spec:
	          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


	          return doneResult();
	        }

	        context.method = method;
	        context.arg = arg;

	        while (true) {
	          var delegate = context.delegate;

	          if (delegate) {
	            var delegateResult = maybeInvokeDelegate(delegate, context);

	            if (delegateResult) {
	              if (delegateResult === ContinueSentinel) continue;
	              return delegateResult;
	            }
	          }

	          if (context.method === "next") {
	            // Setting context._sent for legacy support of Babel's
	            // function.sent implementation.
	            context.sent = context._sent = context.arg;
	          } else if (context.method === "throw") {
	            if (state === GenStateSuspendedStart) {
	              state = GenStateCompleted;
	              throw context.arg;
	            }

	            context.dispatchException(context.arg);
	          } else if (context.method === "return") {
	            context.abrupt("return", context.arg);
	          }

	          state = GenStateExecuting;
	          var record = tryCatch(innerFn, self, context);

	          if (record.type === "normal") {
	            // If an exception is thrown from innerFn, we leave state ===
	            // GenStateExecuting and loop back for another invocation.
	            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

	            if (record.arg === ContinueSentinel) {
	              continue;
	            }

	            return {
	              value: record.arg,
	              done: context.done
	            };
	          } else if (record.type === "throw") {
	            state = GenStateCompleted; // Dispatch the exception by looping back around to the
	            // context.dispatchException(context.arg) call above.

	            context.method = "throw";
	            context.arg = record.arg;
	          }
	        }
	      };
	    } // Call delegate.iterator[context.method](context.arg) and handle the
	    // result, either by returning a { value, done } result from the
	    // delegate iterator, or by modifying context.method and context.arg,
	    // setting context.delegate to null, and returning the ContinueSentinel.


	    function maybeInvokeDelegate(delegate, context) {
	      var method = delegate.iterator[context.method];

	      if (method === undefined$1) {
	        // A .throw or .return when the delegate iterator has no .throw
	        // method always terminates the yield* loop.
	        context.delegate = null;

	        if (context.method === "throw") {
	          // Note: ["return"] must be used for ES3 parsing compatibility.
	          if (delegate.iterator["return"]) {
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            context.method = "return";
	            context.arg = undefined$1;
	            maybeInvokeDelegate(delegate, context);

	            if (context.method === "throw") {
	              // If maybeInvokeDelegate(context) changed context.method from
	              // "return" to "throw", let that override the TypeError below.
	              return ContinueSentinel;
	            }
	          }

	          context.method = "throw";
	          context.arg = new TypeError("The iterator does not provide a 'throw' method");
	        }

	        return ContinueSentinel;
	      }

	      var record = tryCatch(method, delegate.iterator, context.arg);

	      if (record.type === "throw") {
	        context.method = "throw";
	        context.arg = record.arg;
	        context.delegate = null;
	        return ContinueSentinel;
	      }

	      var info = record.arg;

	      if (!info) {
	        context.method = "throw";
	        context.arg = new TypeError("iterator result is not an object");
	        context.delegate = null;
	        return ContinueSentinel;
	      }

	      if (info.done) {
	        // Assign the result of the finished delegate to the temporary
	        // variable specified by delegate.resultName (see delegateYield).
	        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

	        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
	        // exception, let the outer generator proceed normally. If
	        // context.method was "next", forget context.arg since it has been
	        // "consumed" by the delegate iterator. If context.method was
	        // "return", allow the original .return call to continue in the
	        // outer generator.

	        if (context.method !== "return") {
	          context.method = "next";
	          context.arg = undefined$1;
	        }
	      } else {
	        // Re-yield the result returned by the delegate method.
	        return info;
	      } // The delegate iterator is finished, so forget it and continue with
	      // the outer generator.


	      context.delegate = null;
	      return ContinueSentinel;
	    } // Define Generator.prototype.{next,throw,return} in terms of the
	    // unified ._invoke helper method.


	    defineIteratorMethods(Gp);
	    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
	    // @@iterator function is called on it. Some browsers' implementations of the
	    // iterator prototype chain incorrectly implement this, causing the Generator
	    // object to not be returned from this call. This ensures that doesn't happen.
	    // See https://github.com/facebook/regenerator/issues/274 for more details.

	    Gp[iteratorSymbol] = function () {
	      return this;
	    };

	    Gp.toString = function () {
	      return "[object Generator]";
	    };

	    function pushTryEntry(locs) {
	      var entry = {
	        tryLoc: locs[0]
	      };

	      if (1 in locs) {
	        entry.catchLoc = locs[1];
	      }

	      if (2 in locs) {
	        entry.finallyLoc = locs[2];
	        entry.afterLoc = locs[3];
	      }

	      this.tryEntries.push(entry);
	    }

	    function resetTryEntry(entry) {
	      var record = entry.completion || {};
	      record.type = "normal";
	      delete record.arg;
	      entry.completion = record;
	    }

	    function Context(tryLocsList) {
	      // The root entry object (effectively a try statement without a catch
	      // or a finally block) gives us a place to store values thrown from
	      // locations where there is no enclosing try statement.
	      this.tryEntries = [{
	        tryLoc: "root"
	      }];
	      tryLocsList.forEach(pushTryEntry, this);
	      this.reset(true);
	    }

	    exports.keys = function (object) {
	      var keys = [];

	      for (var key in object) {
	        keys.push(key);
	      }

	      keys.reverse(); // Rather than returning an object with a next method, we keep
	      // things simple and return the next function itself.

	      return function next() {
	        while (keys.length) {
	          var key = keys.pop();

	          if (key in object) {
	            next.value = key;
	            next.done = false;
	            return next;
	          }
	        } // To avoid creating an additional object, we just hang the .value
	        // and .done properties off the next function object itself. This
	        // also ensures that the minifier will not anonymize the function.


	        next.done = true;
	        return next;
	      };
	    };

	    function values(iterable) {
	      if (iterable) {
	        var iteratorMethod = iterable[iteratorSymbol];

	        if (iteratorMethod) {
	          return iteratorMethod.call(iterable);
	        }

	        if (typeof iterable.next === "function") {
	          return iterable;
	        }

	        if (!isNaN(iterable.length)) {
	          var i = -1,
	              next = function next() {
	            while (++i < iterable.length) {
	              if (hasOwn.call(iterable, i)) {
	                next.value = iterable[i];
	                next.done = false;
	                return next;
	              }
	            }

	            next.value = undefined$1;
	            next.done = true;
	            return next;
	          };

	          return next.next = next;
	        }
	      } // Return an iterator with no values.


	      return {
	        next: doneResult
	      };
	    }

	    exports.values = values;

	    function doneResult() {
	      return {
	        value: undefined$1,
	        done: true
	      };
	    }

	    Context.prototype = {
	      constructor: Context,
	      reset: function reset(skipTempReset) {
	        this.prev = 0;
	        this.next = 0; // Resetting context._sent for legacy support of Babel's
	        // function.sent implementation.

	        this.sent = this._sent = undefined$1;
	        this.done = false;
	        this.delegate = null;
	        this.method = "next";
	        this.arg = undefined$1;
	        this.tryEntries.forEach(resetTryEntry);

	        if (!skipTempReset) {
	          for (var name in this) {
	            // Not sure about the optimal order of these conditions:
	            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	              this[name] = undefined$1;
	            }
	          }
	        }
	      },
	      stop: function stop() {
	        this.done = true;
	        var rootEntry = this.tryEntries[0];
	        var rootRecord = rootEntry.completion;

	        if (rootRecord.type === "throw") {
	          throw rootRecord.arg;
	        }

	        return this.rval;
	      },
	      dispatchException: function dispatchException(exception) {
	        if (this.done) {
	          throw exception;
	        }

	        var context = this;

	        function handle(loc, caught) {
	          record.type = "throw";
	          record.arg = exception;
	          context.next = loc;

	          if (caught) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            context.method = "next";
	            context.arg = undefined$1;
	          }

	          return !!caught;
	        }

	        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	          var entry = this.tryEntries[i];
	          var record = entry.completion;

	          if (entry.tryLoc === "root") {
	            // Exception thrown outside of any try block that could handle
	            // it, so set the completion value of the entire function to
	            // throw the exception.
	            return handle("end");
	          }

	          if (entry.tryLoc <= this.prev) {
	            var hasCatch = hasOwn.call(entry, "catchLoc");
	            var hasFinally = hasOwn.call(entry, "finallyLoc");

	            if (hasCatch && hasFinally) {
	              if (this.prev < entry.catchLoc) {
	                return handle(entry.catchLoc, true);
	              } else if (this.prev < entry.finallyLoc) {
	                return handle(entry.finallyLoc);
	              }
	            } else if (hasCatch) {
	              if (this.prev < entry.catchLoc) {
	                return handle(entry.catchLoc, true);
	              }
	            } else if (hasFinally) {
	              if (this.prev < entry.finallyLoc) {
	                return handle(entry.finallyLoc);
	              }
	            } else {
	              throw new Error("try statement without catch or finally");
	            }
	          }
	        }
	      },
	      abrupt: function abrupt(type, arg) {
	        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	          var entry = this.tryEntries[i];

	          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	            var finallyEntry = entry;
	            break;
	          }
	        }

	        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	          // Ignore the finally entry if control is not jumping to a
	          // location outside the try/catch block.
	          finallyEntry = null;
	        }

	        var record = finallyEntry ? finallyEntry.completion : {};
	        record.type = type;
	        record.arg = arg;

	        if (finallyEntry) {
	          this.method = "next";
	          this.next = finallyEntry.finallyLoc;
	          return ContinueSentinel;
	        }

	        return this.complete(record);
	      },
	      complete: function complete(record, afterLoc) {
	        if (record.type === "throw") {
	          throw record.arg;
	        }

	        if (record.type === "break" || record.type === "continue") {
	          this.next = record.arg;
	        } else if (record.type === "return") {
	          this.rval = this.arg = record.arg;
	          this.method = "return";
	          this.next = "end";
	        } else if (record.type === "normal" && afterLoc) {
	          this.next = afterLoc;
	        }

	        return ContinueSentinel;
	      },
	      finish: function finish(finallyLoc) {
	        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	          var entry = this.tryEntries[i];

	          if (entry.finallyLoc === finallyLoc) {
	            this.complete(entry.completion, entry.afterLoc);
	            resetTryEntry(entry);
	            return ContinueSentinel;
	          }
	        }
	      },
	      "catch": function _catch(tryLoc) {
	        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	          var entry = this.tryEntries[i];

	          if (entry.tryLoc === tryLoc) {
	            var record = entry.completion;

	            if (record.type === "throw") {
	              var thrown = record.arg;
	              resetTryEntry(entry);
	            }

	            return thrown;
	          }
	        } // The context.catch method must only be called with a location
	        // argument that corresponds to a known catch block.


	        throw new Error("illegal catch attempt");
	      },
	      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	        this.delegate = {
	          iterator: values(iterable),
	          resultName: resultName,
	          nextLoc: nextLoc
	        };

	        if (this.method === "next") {
	          // Deliberately forget the last sent value so that we don't
	          // accidentally pass it on to the delegate.
	          this.arg = undefined$1;
	        }

	        return ContinueSentinel;
	      }
	    }; // Regardless of whether this script is executing as a CommonJS module
	    // or not, return the runtime object so that we can declare the variable
	    // regeneratorRuntime in the outer scope, which allows this module to be
	    // injected easily by `bin/regenerator --include-runtime script.js`.

	    return exports;
	  }( // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	  module.exports );

	  try {
	    regeneratorRuntime = runtime;
	  } catch (accidentalStrictMode) {
	    // This module should not be running in strict mode, so the above
	    // assignment should always work unless something is misconfigured. Just
	    // in case runtime.js accidentally runs in strict mode, we can escape
	    // strict mode using a global Function call. This could conceivably fail
	    // if a Content Security Policy forbids using Function, but in that case
	    // the proper solution is to fix the accidental strict mode problem. If
	    // you've misconfigured your bundler to force strict mode and applied a
	    // CSP to forbid Function, and you're not willing to fix either of those
	    // problems, please detail your unique predicament in a GitHub issue.
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	});

	var regenerator = runtime_1;

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	/**
	 *  Available cookie preferences.
	 */
	exports.CookiePreference = void 0;

	(function (CookiePreference) {
	  CookiePreference["SaveOnDevice"] = "saveOnDevice";
	  CookiePreference["BaseAds"] = "baseAds";
	  CookiePreference["PersonalisedAds"] = "personalisedAds";
	})(exports.CookiePreference || (exports.CookiePreference = {}));

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }

	  return arr2;
	}

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}

	function _classCallCheck$1(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$1(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	(function (Object) {
	  function get() {
	    var _global = this || self;

	    delete Object.prototype.__magic__;
	    return _global;
	  }

	  if (typeof globalThis === "object") {
	    return globalThis;
	  }

	  if (this) {
	    return get();
	  } else {
	    Object.defineProperty(Object.prototype, "__magic__", {
	      configurable: true,
	      get: get
	    });
	    var _global = __magic__;
	    return _global;
	  }
	})(Object);

	function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

	function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

	function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	var lib = createCommonjsModule(function (module, exports) {
	  (function (global, factory) {
	    factory(exports) ;
	  })(commonjsGlobal, function (exports) {
	    /**
	     *  Used as a singleton event channel, which does not need any initialization.
	     *  Events can be listened to and emitted from any stage and anywhere.
	     *  Events are emitted over a tree of listeners, e.g. for `action/add-ticket/123`,
	     *  all listeners on `action`, `action/add-ticket` and `action/add-ticket/123` are
	     *  triggered.
	     */

	    var EventBus = /*#__PURE__*/function () {
	      function EventBus(config) {
	        _classCallCheck$1(this, EventBus);

	        // Registered listeners
	        this.listeners = {}; // Internal map that keeps listener metadata by id

	        this._map = {};
	        this._config = config || {};
	      } // Subscribe to events by path


	      _createClass$1(EventBus, [{
	        key: "on",
	        value: function on(path, listener) {
	          if (path.length < 1) {
	            this.listeners.listeners = this.listeners.listeners || [];
	            this.listeners.listeners.push(listener);
	          } else {
	            // Set the root of the tree
	            var root = this.listeners; // Itererate over the path

	            for (var i = 0; i < path.length; i++) {
	              // Get the next node
	              var node = root[path[i]]; // If it is undefined, define it

	              if (!node) {
	                root[path[i]] = {};
	              } // Set the new root


	              root = root[path[i]]; // Check if it is the last part of the path

	              if (i === path.length - 1) {
	                // Make sure listeners is not undefined
	                root.listeners = root.listeners || []; // Add the listener

	                root.listeners.push(listener);
	              }
	            }
	          }

	          var id = this._generateId();

	          this._map[id] = {
	            path: path,
	            listener: listener
	          };
	          return id;
	        }
	        /**
	         * Remove a listener from the event bus
	         * @param id - as provided by the 'on' method
	         */

	      }, {
	        key: "off",
	        value: function off(id) {
	          var _a, _b;

	          if (!this._map[id]) {
	            throw Error('Listener does not exist');
	          }

	          var path = this._map[id].path;
	          var listener = this._map[id].listener;
	          var root = this.listeners;

	          while (path.length > 0) {
	            var part = path.shift();
	            root = root[part];

	            if (path.length < 1) {
	              var index = (_a = root.listeners) === null || _a === void 0 ? void 0 : _a.findIndex(function (value) {
	                return value === listener;
	              });

	              if (index === undefined || index < 0) {
	                throw Error('Listener not found in tree');
	              }

	              (_b = root.listeners) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
	            }
	          }

	          delete this._map[id];
	        } // Emit data to it's listeners by path

	      }, {
	        key: "emit",
	        value: function emit(path, data) {
	          // If the env is development, log all events to the console
	          if (this._config.isDebug) {
	            // eslint-disable-next-line no-console
	            console.info('EVENT', path, data);
	          } // Array of relevant listeners


	          var to = []; // Set the root of the tree

	          var root = this.listeners; // Iterate over the path's parts

	          for (var i = 0; i <= path.length; i++) {
	            // If the current node has listeners,
	            // add them to the list of relevant listeners
	            if (root.listeners) {
	              to = [].concat(_toConsumableArray(to), _toConsumableArray(root.listeners));
	            } // Check if the next node exists


	            if (root[path[i]]) {
	              // If it does, set it as new root
	              root = root[path[i]];
	            } else {
	              // Otherwise, stop iterating
	              break;
	            }
	          } // Notify all listeners


	          var _iterator = _createForOfIteratorHelper(to),
	              _step;

	          try {
	            var _loop = function _loop() {
	              var listener = _step.value;

	              var pathCopy = _toConsumableArray(path);

	              if (data && _typeof(data) === 'object') {
	                data = JSON.parse(JSON.stringify(data));
	              }

	              setTimeout(function () {
	                listener(pathCopy, data);
	              }, 0);
	            };

	            for (_iterator.s(); !(_step = _iterator.n()).done;) {
	              _loop();
	            }
	          } catch (err) {
	            _iterator.e(err);
	          } finally {
	            _iterator.f();
	          }
	        }
	        /**
	         * Basic id generator
	         * src: https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
	         */

	      }, {
	        key: "_generateId",
	        value: function _generateId() {
	          var dt = new Date().getTime();
	          var id = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) {
	            var r = (dt + Math.random() * 16) % 16 | 0;
	            dt = Math.floor(dt / 16);
	            return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	          });
	          return id;
	        }
	      }]);

	      return EventBus;
	    }();

	    var EventScope = /*#__PURE__*/function () {
	      function EventScope(eventBus) {
	        _classCallCheck$1(this, EventScope);

	        this._eventBus = eventBus;
	      }
	      /**
	       *  Listen to events by providing a path and a callback to the `on` function
	       *  @param path - Path to listen to
	       *  @param cb - Will be called when an event occurs
	       */


	      _createClass$1(EventScope, [{
	        key: "on",
	        value: function on(path, cb) {
	          var noScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	          // If the path is not yet an array, use it as a single path segment
	          if (!Array.isArray(path)) {
	            if (path === '*') {
	              path = [];
	            } else {
	              path = [path];
	            }
	          } else {
	            path = _toConsumableArray(path);
	          } // If the eventScope is set, prefix the path with it


	          if (this._eventScope && !noScope) {
	            path = [this._eventScope].concat(_toConsumableArray(path));
	          } // Relay to the actual event bus


	          return this._eventBus.on(path, cb);
	        }
	        /**
	         * Remove a listener from the event bus
	         * @param id - listener id as provided by the 'on' method
	         */

	      }, {
	        key: "off",
	        value: function off(id) {
	          this._eventBus.off(id);
	        }
	        /**
	         *  Emit an event from the eventScope
	         *  @param path - The path on which the event occurred
	         *  @param payload - The data to be send
	         */

	      }, {
	        key: "emit",
	        value: function emit(path, payload) {
	          var noScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	          // If the path is not yet an array, use it as a single path segment
	          if (!Array.isArray(path)) {
	            path = [path];
	          } // If the eventScope is set, prefix the path with it


	          if (this._eventScope && !noScope) {
	            path = [this._eventScope].concat(_toConsumableArray(path));
	          } // Relay to the actual event bus


	          this._eventBus.emit(path, payload);
	        }
	      }]);

	      return EventScope;
	    }();

	    var EventBusSingleton = new EventBus();
	    exports.EventBusSingleton = EventBusSingleton;
	    exports.EventScope = EventScope;
	    exports["default"] = EventBus;
	    Object.defineProperty(exports, '__esModule', {
	      value: true
	    });
	  });
	});
	var EventBus = /*@__PURE__*/getDefaultExportFromCjs(lib);

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;

	  if (!css || typeof document === 'undefined') {
	    return;
	  }

	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';

	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }

	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z = ".ot-cookies {\n  display: none;\n  position: fixed;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  transition: var(--ot-transition-all);\n  background: transparent !important;\n}\n.ot-cookies__modal {\n  opacity: 0;\n  position: absolute;\n  width: 25rem;\n  text-align: center;\n  padding: var(--ot-spacing-2xl);\n  background: white;\n  box-shadow: var(--ot-shadow-2xl);\n  border-radius: 12px;\n  left: 50%;\n  transition: var(--ot-transition-all);\n}\n.ot-cookies__modal--center {\n  top: 50%;\n  transform: translateX(-50%) translateY(-40%);\n}\n.ot-cookies__modal--top {\n  top: 1rem;\n  transform: translateX(-50%) translateY(-10%);\n}\n.ot-cookies__modal__content {\n  overflow: hidden;\n  transition-property: opacity, max-height;\n  transition-duration: 0.2s, 0.5s;\n  transition-timing-function: ease-in-out, ease-in-out;\n}\n.ot-cookies__modal__content--hide {\n  opacity: 0;\n}\n.ot-cookies__modal__title {\n  margin-bottom: 1rem !important;\n}\n.ot-cookies__modal__introduction {\n  color: var(--ot-color-core-foreground);\n}\n.ot-cookies__modal__introduction--no-margin {\n  margin: 0;\n}\n.ot-cookies__modal__link {\n  display: block;\n  cursor: pointer;\n  color: var(--ot-color-core-brand);\n  font-weight: 500;\n  margin: var(--ot-spacing-lg) 0 var(--ot-spacing-2xl);\n}\n.ot-cookies__modal__preferences {\n  list-style-type: none;\n  padding: 0;\n  margin: var(--ot-spacing-3xl) var(--ot-spacing-lg);\n  text-align: left;\n  color: var(--ot-color-core-foreground);\n}\n.ot-cookies__modal__preference {\n  display: block;\n}\n.ot-cookies__modal__preference:not(:last-of-type) {\n  margin-bottom: var(--ot-spacing-lg);\n}\n.ot-cookies--paint {\n  display: block;\n}\n.ot-cookies--paint .ot-cookies__modal {\n  display: block;\n}\n.ot-cookies--show {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n.ot-cookies--show .ot-cookies__modal {\n  opacity: 1;\n}\n.ot-cookies--show .ot-cookies__modal--center {\n  transform: translateX(-50%) translateY(-50%);\n}\n.ot-cookies--show .ot-cookies__modal--top {\n  transform: translateX(-50%);\n}\n\n@media all and (max-width: 768px) {\n  .ot-cookies__modal {\n    width: 80%;\n  }\n  .ot-cookies__modal__preferences {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}";
	styleInject(css_248z);

	var _DEFAULT_PREFERENCES;

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	/**
	 *  Forward to the _accept method to accept all cookies.
	 */

	var ACCEPT_ALL_COOKIES = true;
	/**
	 *  The default preferences (accept all).
	 */

	var DEFAULT_PREFERENCES = (_DEFAULT_PREFERENCES = {}, _defineProperty(_DEFAULT_PREFERENCES, exports.CookiePreference.SaveOnDevice, true), _defineProperty(_DEFAULT_PREFERENCES, exports.CookiePreference.BaseAds, true), _defineProperty(_DEFAULT_PREFERENCES, exports.CookiePreference.PersonalisedAds, true), _DEFAULT_PREFERENCES);
	/**
	 *  TODO: Separate language files, served from the CDN?
	 */

	var screens = {
	  landing: {
	    title: 'Cookies',
	    introduction: 'We use cookies to make your life easier by remembering what you’ve added to your cart so you can pick up right where you left off, as well as many other smart ways to enhance your experience.',
	    link: {
	      title: 'Click to see and change your cookie preferences',
	      text: 'Change cookie preferences'
	    },
	    actions: {
	      accept: {
	        title: 'Click to accept all cookies',
	        text: 'Accept all'
	      }
	    }
	  },
	  preferences: {
	    introduction: 'Personalise your cookie experience',
	    labels: {
	      saveOnDevice: 'Information saved on device',
	      baseAds: 'Base advertisements',
	      personalisedAds: 'Personal advertisements'
	    },
	    actions: {
	      acceptAll: {
	        title: 'Click to accept all the cookies',
	        text: 'Accept all'
	      },
	      accept: {
	        title: 'Click to accept the selected cookies',
	        text: 'Accept'
	      }
	    }
	  }
	};
	/**
	 *  Class for the cookies' modal. Including every piece of
	 *  logic to create and inject the DOM elements and allowing
	 *  the user to change his cookie preferences.
	 */

	var OpenTicketCookiesModal = /*#__PURE__*/function (_EventScope) {
	  _inherits(OpenTicketCookiesModal, _EventScope);

	  var _super = _createSuper(OpenTicketCookiesModal);

	  function OpenTicketCookiesModal(config) {
	    var _this;

	    _classCallCheck(this, OpenTicketCookiesModal);

	    var _a;

	    _this = _super.call(this, new EventBus());
	    _this._eventScope = 'ot-cookies-modal'; // Holding the values of the preferences

	    _this._preferences = {}; // Validate and set the config if provided

	    if (config) {
	      _this._config = config;

	      if (config.introduction) {
	        _this._config.texts = Object.assign(Object.assign({}, _this._config.texts), {
	          landing: Object.assign(Object.assign({}, (_a = _this._config.texts) === null || _a === void 0 ? void 0 : _a.landing), {
	            introduction: config.introduction
	          })
	        });
	      }
	    } else {
	      _this._config = {};
	    }

	    if (!_this._config.position) {
	      _this._config.position = 'center';
	    }

	    return _this;
	  }
	  /**
	   *
	   *  The needed stylesheets are injected, before injecting
	   *  the cookies' DOM elements and building the correct
	   *  preferences object.
	   *
	   *  (i) Injecting the cookies' DOM elements happen with a
	   *  delay to make sure the stylesheets are loaded, and the
	   *  DOM elements are hidden by them by default.
	   *
	   *  @param prefs The preferences to use. Not providing them
	   *  makes it fall back to the DEFAULT_PREFERENCES
	   *
	   */


	  _createClass(OpenTicketCookiesModal, [{
	    key: "mount",
	    value: function mount(prefs) {
	      this._injectCookies(); // Construct the preferences based on the forwarded ones or the defaults


	      var preferences = prefs || DEFAULT_PREFERENCES;

	      for (var _i = 0, _Object$keys = Object.keys(preferences); _i < _Object$keys.length; _i++) {
	        var pref = _Object$keys[_i];
	        this._preferences[pref] = preferences[pref];
	      }
	    }
	    /**
	     *  Used to construct and inject the HTML for the cookies into the document.
	     */

	  }, {
	    key: "_injectCookies",
	    value: function _injectCookies() {
	      this._cookies = this._createCookies();

	      this._landingBuilder();

	      document.body.prepend(this._cookies);

	      this._show();
	    }
	    /**
	     *  Creates and returns the cookies' DOM elements.
	     */

	  }, {
	    key: "_createCookies",
	    value: function _createCookies() {
	      var cookies = document.createElement('div');
	      var modal = document.createElement('div');
	      cookies.className = 'ot-document ot-content ot-cookies';
	      modal.className = 'ot-cookies__modal';

	      if (this._config.position === 'top') {
	        modal.classList.add('ot-cookies__modal--top');
	      } else if (this._config.position === 'center') {
	        modal.classList.add('ot-cookies__modal--center');
	      }

	      this._content = document.createElement('div');
	      this._content.className = 'ot-cookies__modal__content';
	      modal.appendChild(this._content);
	      cookies.appendChild(modal);
	      return cookies;
	    }
	    /**
	     *  Function for returning the configured or default text.
	     */

	  }, {
	    key: "getScreenText",
	    value: function getScreenText(path) {
	      var findIn = function findIn(obj) {
	        return path.split('.').reduce(function (prev, curr) {
	          return prev && prev[curr];
	        }, obj);
	      };

	      return findIn(this._config.texts) || findIn(screens);
	    }
	    /**
	     *  Function for building the landing screen.
	     */

	  }, {
	    key: "_landingBuilder",
	    value: function _landingBuilder() {
	      var _this2 = this;

	      // Create and add the title and introduction
	      var title = document.createElement('h2');
	      title.className = 'ot-cookies__modal__title';
	      title.innerText = this.getScreenText('landing.title');
	      var introduction = document.createElement('p');
	      introduction.innerText = this.getScreenText('landing.introduction');
	      introduction.className = 'ot-cookies__modal__introduction';

	      this._content.appendChild(title);

	      this._content.appendChild(introduction); // Create and add the link that allows the user to
	      // go to the preferences screen


	      var link = document.createElement('a');
	      link.title = this.getScreenText('landing.link.title');
	      link.innerText = this.getScreenText('landing.link.text');
	      link.className = 'ot-cookies__modal__link';
	      link.id = 'change_prefs';
	      link.addEventListener('click', this._replaceContent.bind(this, this._preferencesBuilder));

	      this._content.appendChild(link); // Create and add the accept button


	      var accept = document.createElement('button');
	      accept.title = this.getScreenText('landing.actions.accept.title');
	      accept.innerText = this.getScreenText('landing.actions.accept.text');
	      accept.id = 'accept_all';
	      accept.addEventListener('click', function (event) {
	        _this2._accept(event, ACCEPT_ALL_COOKIES);
	      });

	      this._content.appendChild(accept);
	    }
	    /**
	     *
	     *  Function for building the preferences screen.
	     *
	     *  @param cb Callback to invoke when done building
	     *
	     */

	  }, {
	    key: "_preferencesBuilder",
	    value: function _preferencesBuilder(cb) {
	      var _this3 = this;

	      var introduction = document.createElement('p');
	      introduction.innerText = this.getScreenText('preferences.introduction');
	      introduction.className = 'ot-cookies__modal__introduction ot-cookies__modal__introduction--no-margin';

	      this._content.appendChild(introduction);
	      /**
	       *  Construct a list of preferences with a toggle for every
	       *  preference, based on the set preferences in the
	       *  constructor and OpenTicket's Design System.
	       */


	      var preferences = document.createElement('ul');
	      preferences.className = 'ot-cookies__modal__preferences ot-toggle-group is-right-aligned';

	      var _loop = function _loop(p) {
	        // Construct the right id for linking the checkbox/label
	        var id = "preferences_".concat(p.toLowerCase()); // Preference's list item

	        var preference = document.createElement('li');
	        preference.className = 'ot-cookies__modal__preference'; // The outer ot toggle wrapper

	        var toggleWrapper = document.createElement('div');
	        toggleWrapper.className = 'ot-toggle'; // The first label element of the ot toggle: representing the graphic toggle

	        var input = document.createElement('label');
	        input.className = 'ot-toggle-input'; // The actual checkbox input

	        var checkbox = document.createElement('input');
	        checkbox.className = 'ot-toggle-input__input';
	        checkbox.type = 'checkbox';
	        checkbox.id = id;
	        checkbox.checked = _this3._preferences[p];
	        input.appendChild(checkbox); // The two spans for the graphic toggle: the label being
	        // the bar and the handle being the handle

	        var toggleLabel = document.createElement('span');
	        var toggleHandle = document.createElement('span');
	        toggleLabel.className = 'ot-toggle-input__label';
	        toggleHandle.className = 'ot-toggle-input__handle';
	        input.appendChild(toggleLabel);
	        input.appendChild(toggleHandle); // The actual label text

	        var label = document.createElement('label');
	        label.className = 'ot-toggle-label';
	        label.innerText = _this3.getScreenText("preferences.labels.".concat(p)) || 'Unkown preference';
	        label.htmlFor = id; // Add both the input (graphical toggle) as the label to the wrapper

	        toggleWrapper.appendChild(input);
	        toggleWrapper.appendChild(label); // Keep the preference settings synced when a user toggles

	        toggleWrapper.addEventListener('click', function () {
	          _this3._preferences[p] = checkbox.checked;
	        }); // Add the toggle to the preference and the preference to the list

	        preference.appendChild(toggleWrapper);
	        preferences.appendChild(preference);
	      };

	      for (var p in this._preferences) {
	        _loop(p);
	      }

	      this._content.appendChild(preferences); // Create and add the accept all button


	      var acceptAll = document.createElement('button');
	      acceptAll.title = this.getScreenText('preferences.actions.acceptAll.title');
	      acceptAll.innerText = this.getScreenText('preferences.actions.acceptAll.text');
	      acceptAll.className = 'is-dark';
	      acceptAll.id = 'accept_all';
	      acceptAll.addEventListener('click', function (event) {
	        _this3._accept(event, ACCEPT_ALL_COOKIES);
	      });

	      this._content.appendChild(acceptAll); // Create and add the accept button


	      var accept = document.createElement('button');
	      accept.title = this.getScreenText('preferences.actions.accept.title');
	      accept.innerText = this.getScreenText('preferences.actions.accept.text');
	      accept.style.marginLeft = 'var(--ot-spacing-sm)';
	      accept.id = 'accept';
	      accept.addEventListener('click', function (event) {
	        _this3._accept(event, !ACCEPT_ALL_COOKIES);
	      });

	      this._content.appendChild(accept);

	      cb();
	    }
	    /**
	     *
	     *  Used for replacing the content of the cookies' modal with the
	     *  content that is built with the forwarded content builder.
	     *
	     *  It fades the content out (CSS), cleans the content wrapper,
	     *  let's the forwarded builder fn build the new content and
	     *  finally fades the content back in again (CSS).
	     *
	     *  @param contentBuilder Function which builds the new content
	     *
	     */

	  }, {
	    key: "_replaceContent",
	    value: function _replaceContent(contentBuilder) {
	      var _this4 = this;

	      this._content.classList.add('ot-cookies__modal__content--hide');

	      setTimeout(function () {
	        _this4._content.style.maxHeight = "".concat(_this4._content.clientHeight, "px");

	        while (_this4._content.lastChild) {
	          _this4._content.removeChild(_this4._content.lastChild);
	        }

	        contentBuilder.call(_this4, function () {
	          setTimeout(function () {
	            _this4._content.style.maxHeight = '999px';
	            setTimeout(function () {
	              _this4._content.classList.remove('ot-cookies__modal__content--hide');
	            }, 500);
	          }, 200);
	        });
	      }, 200);
	    }
	    /**
	     *  Used to let the cookies' modal appear, based on CSS animations.
	     */

	  }, {
	    key: "_show",
	    value: function _show() {
	      var _this5 = this;

	      this._cookies.classList.add('ot-cookies--paint'); // Give it some time to change his display status in the DOM


	      setTimeout(function () {
	        _this5._cookies.classList.add('ot-cookies--show');
	      }, 250);
	    }
	    /**
	     *
	     *  Used to close the cookies' modal.
	     *
	     *  @param event DOM event of the invoking click
	     *
	     */

	  }, {
	    key: "_close",
	    value: function _close(event) {
	      var _this6 = this;

	      event === null || event === void 0 ? void 0 : event.preventDefault();

	      this._cookies.classList.remove('ot-cookies--show');

	      setTimeout(function () {
	        _this6._cookies.classList.remove('ot-cookies--paint');

	        setTimeout(_this6._cleanDOM.bind(_this6), 500);
	      }, 500);
	    }
	    /**
	     *
	     *  Used to accept the preferences: closing the cookies'
	     *  modal and emitting the set preferences.
	     *
	     *  @param event DOM event of the invoking click
	     *  @param all If all the cookies should be accepted
	     *
	     */

	  }, {
	    key: "_accept",
	    value: function _accept(event, all) {
	      this._close(event);

	      if (all === ACCEPT_ALL_COOKIES) {
	        for (var pref in this._preferences) {
	          this._preferences[pref] = true;
	        }
	      }

	      this.emit('accept', this._preferences);
	    }
	    /**
	     *  Used to clean the DOM after the cookies' modal has been closed.
	     */

	  }, {
	    key: "_cleanDOM",
	    value: function _cleanDOM() {
	      this._cookies.remove();
	    }
	  }]);

	  return OpenTicketCookiesModal;
	}(lib.EventScope);

	function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	/**
	 *  The default location of the cookie server, used
	 *  if no server is forwarded via the config.
	 */

	var DEFAULT_COOKIE_SERVER = 'https://cookies.openticket.tech/latest/provider/index.html';
	/**
	 *  The default config for the injector, used if
	 *  no config is forwarded to the init method.
	 */

	var DEFAULT_CONFIG = {
	  server: DEFAULT_COOKIE_SERVER
	};
	/**
	 *  The id of the first, initial message to the cookie server, which
	 *  responds with the cookie preferences of the user if set/available.
	 */

	var INIT_ID = 'INIT';
	/**
	 *  Key used to place the message id in.
	 */

	var ID_KEY = '_messageId';
	/**
	 *  The operation for instantiation of the
	 *  injector and provider message bridge.
	 */

	var INSTANTIATE_OPERATION = 'HELLO';
	/**
	 *  If no response is received after PROMISE_TIMEOUT
	 *  milliseconds, the promise will be rejected.
	 */

	var PROMISE_TIMEOUT = 5000;
	/**
	 *  Flags that are added (with true as value) to the message objects
	 *  between the injector and provider, letting both the injector and
	 *  the provider know the message came from the other.
	 */

	exports.OtCookiesFlag = void 0;

	(function (OtCookiesFlag) {
	  OtCookiesFlag["Injector"] = "_isOpenTicketCookiesInjector";
	  OtCookiesFlag["Provider"] = "_isOpenTicketCookiesProvider";
	})(exports.OtCookiesFlag || (exports.OtCookiesFlag = {}));
	/**
	 *  Possible operations that the injector
	 *  can request from the provider.
	 */


	var Operation;

	(function (Operation) {
	  Operation["Init"] = "INIT";
	  Operation["FetchPrefs"] = "FETCH_PREFS";
	  Operation["SetPrefs"] = "SET_PREFS";
	  Operation["RemovePrefs"] = "REMOVE_PREFS";
	})(Operation || (Operation = {}));
	/**
	 *
	 *  The whitelist of domains. Be very careful when modifying these! Having any
	 *  origins in this list that are vulnerable to stuff like XSS causes random
	 *  pages to be able to check if a visitor of their website is an openticket
	 *  user and some data (guid, name, email).
	 *
	 *  (!) Do not change without thinking to prevent data breaches
	 *
	 */


	var whitelist = [
	/** DEVELOP ORIGINS */
	'http://eventix.local:8000', 'http://eventix.local:5757', 'http://eventix.local:52201', 'http://localhost:8000', 'http://localhost:5757', 'http://localhost:52201', 'http://en.statamic.test',
	/** EVENTIX ORIGINS */
	'https://de.preview.cms.eventix.io', 'https://nl.preview.cms.eventix.io', 'https://en.preview.cms.eventix.io', 'https://es.preview.cms.eventix.io', 'https://eventix.de', 'https://eventix.io', 'https://eventix.nl', 'https://eventix.es', 'https://www.eventix.de', 'https://www.eventix.io', 'https://www.eventix.nl', 'https://www.eventix.es', 'https://pos.eventix.io'];
	/**
	 *  An instance of this class can be used to access OpenTicket's
	 *  cookie preferences provider cross-domain.
	 */

	var OpenTicketCookiesInjector = /*#__PURE__*/function (_EventScope) {
	  _inherits(OpenTicketCookiesInjector, _EventScope);

	  var _super = _createSuper$1(OpenTicketCookiesInjector);

	  function OpenTicketCookiesInjector() {
	    var _this;

	    _classCallCheck(this, OpenTicketCookiesInjector);

	    _this = _super.call(this, new EventBus());
	    _this._eventScope = 'ot-cookies'; // Internal state

	    _this._config = DEFAULT_CONFIG;
	    _this._initialized = false; // Message queue, promises awaiting a response to be settled

	    _this._queue = {};
	    return _this;
	  } // Returns true when initialization is finished


	  _createClass(OpenTicketCookiesInjector, [{
	    key: "initialized",
	    get: function get() {
	      return this._initialized;
	    }
	    /**
	     *  Used to initialize the injector: it creates and appends the iFrame
	     *  to the document body, sets up the communication to the cookie server
	     *  and returns the user's cookie preferences if set/available.
	     */

	  }, {
	    key: "init",
	    value: function init(config, cb) {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
	        var _this2 = this;

	        var url, userPreferencesPromise, preferences;
	        return regenerator.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!this._queue[INIT_ID]) {
	                  _context.next = 2;
	                  break;
	                }

	                throw Error('Init is running');

	              case 2:
	                if (!this._initialized) {
	                  _context.next = 4;
	                  break;
	                }

	                throw Error('Already initialized');

	              case 4:
	                if (!config) {
	                  _context.next = 8;
	                  break;
	                }

	                if (!(config.server && typeof config.server !== 'string')) {
	                  _context.next = 7;
	                  break;
	                }

	                throw Error("Invalid server URL config provided: ".concat(config.server));

	              case 7:
	                this._config = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);

	              case 8:
	                // Cosntruct the fallback storage module
	                this._storage = new OpenTicketCookieStorage(); // Construct the modal with the forwarded modal config

	                this._modal = new OpenTicketCookiesModal(this._config.modal); // Get the origin of the url

	                url = new URL(this._config.server);
	                this._serverOrigin = url.origin; // Initialize the listener

	                window.addEventListener('message', this._onMessage.bind(this), false); // Adding the initial request to the queue
	                // (i) which gets executed in the _onMessage method,
	                // after the server/iframe has made the first move

	                userPreferencesPromise = new Promise(function (resolve, reject) {
	                  _this2._queue[INIT_ID] = {
	                    resolve: resolve,
	                    reject: reject,
	                    cb: cb
	                  };
	                }); // Mount the iFrame

	                _context.next = 16;
	                return this._mountIframe();

	              case 16:
	                _context.next = 18;
	                return userPreferencesPromise;

	              case 18:
	                preferences = _context.sent;

	                // If the user already has set his cookie preferences before
	                // (which might have happened via another domain), save them
	                // in this instance
	                if (preferences) {
	                  this.preferences = preferences;
	                }

	                this._initialized = true;
	                return _context.abrupt("return", preferences);

	              case 22:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	    }
	    /**
	     *  Constructs, mounts and opens the cookies' modal.
	     */

	  }, {
	    key: "openCookiesModal",
	    value: function openCookiesModal() {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee3() {
	        var _this3 = this;

	        return regenerator.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this._modal.mount(this.preferences || undefined);
	                /**
	                 *  Listen to accept events. Send the accepted preferences
	                 *  to the cookie server, save them in the local public prop
	                 *  and emit an accept event to allow users of the
	                 *  injector to hook into.
	                 */


	                this._modal.on('accept', function (_path, preferences) {
	                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee2() {
	                    return regenerator.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _context2.next = 2;
	                            return this._sendAndAwait({
	                              operation: Operation.SetPrefs,
	                              preferences: preferences
	                            });

	                          case 2:
	                            this.preferences = this._storage.set(preferences);
	                            this.emit('accept', preferences);

	                          case 4:
	                          case "end":
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, this);
	                  }));
	                });

	              case 2:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	    }
	    /**
	     *
	     *  Public handle to allow users to clean the cookie
	     *  preferences: removing the cookie from the server.
	     *
	     *  (i) Forwarding the result, which is undefined
	     *  if it got cleaned correctly.
	     *
	     */

	  }, {
	    key: "cleanCookiePreferences",
	    value: function cleanCookiePreferences(cb) {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee4() {
	        return regenerator.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this._storage.remove();

	                _context4.prev = 1;
	                _context4.next = 4;
	                return this._sendAndAwait({
	                  operation: Operation.RemovePrefs
	                }, cb);

	              case 4:
	                this.preferences = _context4.sent;
	                _context4.next = 9;
	                break;

	              case 7:
	                _context4.prev = 7;
	                _context4.t0 = _context4["catch"](1);

	              case 9:
	                this.emit('clean', this.preferences);

	              case 10:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this, [[1, 7]]);
	      }));
	    }
	    /**
	     *
	     *  Handler for received messages from the provider.
	     *
	     *  @param event A message received from the provider (iframe).
	     *
	     */

	  }, {
	    key: "_onMessage",
	    value: function _onMessage(event) {
	      // Make sure the message comes from the provider iframe for security reasons
	      if (!event.data[exports.OtCookiesFlag.Provider] || event.origin !== this._serverOrigin) {
	        return;
	      } // Check if it's the initial message from the server


	      if (event.data.operation === INSTANTIATE_OPERATION) {
	        var _this$_sendPostMessag;

	        // Store the server's iframe window to be able to send messages to it
	        // (i) MessageEvent source is not supported in IE
	        this._server = event.source || this._iframe.contentWindow; // We need a ref to the server's iframe window to be able to communicate

	        if (!this._server) {
	          throw Error('Can\'t access the server\'s window to communicate');
	        } // Send the initial request
	        // (i) Added to the queue in the init method


	        return this._sendPostMessage((_this$_sendPostMessag = {}, _defineProperty(_this$_sendPostMessag, ID_KEY, INIT_ID), _defineProperty(_this$_sendPostMessag, "operation", Operation.Init), _this$_sendPostMessag));
	      }

	      var data = event.data;
	      var id = data[ID_KEY]; // Check if the id matches a queued request

	      var request = this._queue[id];

	      if (!request) {
	        return;
	      }

	      var result;

	      if (!data.success) {
	        request.reject(data.error);

	        if (request.cb) {
	          request.cb(undefined);
	        }
	      } else {
	        result = event.data.preferences;

	        if (!result) {
	          result = this._storage.get();
	        }

	        request.resolve(result);

	        if (request.cb) {
	          request.cb(result);
	        }
	      }

	      delete this._queue[id];
	    }
	    /**
	     *
	     *  Used to add a request (message) to the queue, post it and await the response (with a timeout).
	     *
	     *  @param data An object containing the data to send
	     *  @param cb The callback to invoke once the request is settled
	     *
	     */

	  }, {
	    key: "_sendAndAwait",
	    value: function _sendAndAwait(data, cb) {
	      var _this4 = this;

	      var id = this._generateMessageId();

	      return new Promise(function (resolve, reject) {
	        _this4._queue[id] = {
	          resolve: resolve,
	          reject: reject,
	          cb: cb
	        };

	        _this4._sendPostMessage(Object.assign(Object.assign({}, data), _defineProperty({}, ID_KEY, id))); // Discard the message from the queue after the time out


	        setTimeout(function () {
	          reject('Time-out');

	          if (cb) {
	            cb(undefined);
	          }

	          delete _this4._queue[id];
	        }, PROMISE_TIMEOUT);
	      });
	    }
	    /**
	     *
	     *  Used to send a post message to the cookies server's iframe.
	     *
	     *  @param data An object containing the data to send
	     *
	     */

	  }, {
	    key: "_sendPostMessage",
	    value: function _sendPostMessage(data) {
	      this._server.postMessage(Object.assign(Object.assign({}, data), _defineProperty({}, exports.OtCookiesFlag.Injector, true)), this._serverOrigin);
	    }
	    /**
	     *  Definitely not safe, but good enough for this use case.
	     */

	  }, {
	    key: "_generateMessageId",
	    value: function _generateMessageId() {
	      return Math.random().toString(12);
	    }
	    /**
	     *  Used to mount the invisible iframe in the document body
	     *  which holds a direct link to the cookie server.
	     */

	  }, {
	    key: "_mountIframe",
	    value: function _mountIframe() {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee5() {
	        var _this5 = this;

	        return regenerator.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                return _context5.abrupt("return", new Promise(function (resolve, reject) {
	                  var iframe = document.createElement('iframe');
	                  iframe.src = _this5._config.server;
	                  iframe.style.display = 'none';

	                  iframe.onload = function () {
	                    if (!iframe.contentWindow) {
	                      return reject('Can\'t access contentWindow of iframe for communicating with the server');
	                    }

	                    _this5._iframe = iframe;
	                    resolve();
	                  };

	                  iframe.onerror = reject;
	                  iframe.onabort = reject;
	                  document.body.appendChild(iframe);
	                }));

	              case 1:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5);
	      }));
	    }
	  }]);

	  return OpenTicketCookiesInjector;
	}(lib.EventScope);
	/**
	 *
	 *  This class should be initialized on the domain that holds
	 *  the cookies details of a user, which in turn must be
	 *  loaded into an iframe.
	 *
	 *  It will provide the cookie preferences to whitelisted
	 *  domains that cannot access this data directly.
	 *
	 */


	var OpenTicketCookiesProvider = /*#__PURE__*/function () {
	  function OpenTicketCookiesProvider(cookies) {
	    _classCallCheck(this, OpenTicketCookiesProvider);

	    this._storage = cookies || new OpenTicketCookieStorage();
	  }

	  _createClass(OpenTicketCookiesProvider, [{
	    key: "init",
	    value: function init() {
	      this._mountInjectorListener();
	    }
	    /**
	     *  Used to mount the injector listener.
	     */

	  }, {
	    key: "_mountInjectorListener",
	    value: function _mountInjectorListener() {
	      // It must be loaded in an iframe
	      if (!window.parent) {
	        throw Error('OpenTicketCookiesProvider: Cannot initialize without window.parent, it must be loaded in an iframe');
	      }

	      window.addEventListener('message', this._onMessage.bind(this), false);
	      /**
	       *
	       *  Let the parent know the messaging channel is initialized.
	       *
	       *  (!) For security reasons, the communication has to be initiated by
	       *  the iframe (in a cross-domain setting), not the other way around.
	       *
	       */

	      this._sendPostMessage({
	        operation: INSTANTIATE_OPERATION
	      });
	    }
	    /**
	     *
	     *  Handler for received messages from the injector.
	     *
	     *  @param event A message received from the injector.
	     *
	     */

	  }, {
	    key: "_onMessage",
	    value: function _onMessage(event) {
	      // Make sure the message comes from the injector
	      // and a whitelisted domain for security reasons
	      if (!event.data[exports.OtCookiesFlag.Injector] || !whitelist.includes(event.origin)) {
	        return;
	      }

	      var data = event.data;
	      var id = data[ID_KEY];
	      var response;

	      switch (data.operation) {
	        // Also try to get the user's preferences on init
	        case Operation.Init:
	        case Operation.FetchPrefs:
	          response = {
	            preferences: this._storage.get(),
	            success: true
	          };
	          break;

	        case Operation.SetPrefs:
	          response = {
	            preferences: this._storage.set(data.preferences),
	            success: true
	          };
	          break;

	        case Operation.RemovePrefs:
	          response = {
	            preferences: this._storage.remove(),
	            success: true
	          };
	          break;
	      }

	      if (response) {
	        this._sendPostMessage(Object.assign(Object.assign({}, response), _defineProperty({}, ID_KEY, id)));
	      }
	    }
	    /**
	     *
	     *  Used to send a post message to the parent window.
	     *
	     *  @param data An object containing the data to send
	     *
	     */

	  }, {
	    key: "_sendPostMessage",
	    value: function _sendPostMessage(data) {
	      window.parent.postMessage(Object.assign(Object.assign({}, data), _defineProperty({}, exports.OtCookiesFlag.Provider, true)), '*');
	    }
	  }]);

	  return OpenTicketCookiesProvider;
	}();
	/**
	 *  Make sure the OpenTicket namespace exists and add methods
	 *  for creating both the injector as the provider to it.
	 */


	window.OpenTicket = window.OpenTicket || {};

	window.OpenTicket.createCookiesInjector = function () {
	  return new OpenTicketCookiesInjector();
	};

	window.OpenTicket.createCookiesProvider = function () {
	  return new OpenTicketCookiesProvider();
	};

	window.OpenTicket = window.OpenTicket || {};
	window.OpenTicket.CookiePrefs = new OpenTicketCookieStorage();

	exports.OpenTicketCookieStorage = OpenTicketCookieStorage;
	exports.OpenTicketCookiesInjector = OpenTicketCookiesInjector;
	exports.OpenTicketCookiesProvider = OpenTicketCookiesProvider;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
